import { PeriodProvider } from "@/providers/Period";
import { FileText } from "@phosphor-icons/react";
import { lazy } from "react";

const RelatorioDashboard = lazy(() =>
  import("./Dashboard").then((m) => ({ default: m.RelatorioDashboard })),
);
const RelatorioAbastecimento = lazy(() => import("./Abastecimento"));
const RelatorioVecimento = lazy(() => import("./Vencimento"));
const RelatorioFotos = lazy(() => import("./Fotos"));
const PainelExpedicao = lazy(() => import("../Expedicoes/Relatorio"));
const RelatorioCote = lazy(() => import("./Corte"));
const Endereco = lazy(() => import("./Endereco"));
const Estoques = lazy(() => import("./Estoques"));
const ExtratoMovimentacao = lazy(() => import("./Extrato"));
const RelatorioInventario = lazy(() =>
  import("./Inventario").then((m) => ({ default: m.RelatorioInventario })),
);
const ManifestoEntrega = lazy(() => import("./ManifestoEntrega"));
const BuscarManifestoEntrega = lazy(() => import("./ManifestoEntrega/Buscar"));

const ModuleRelatorio = {
  menuItem: {
    to: "/relatorio",
    title: "Relatórios",
    icon: FileText,
    id: 11,
    childrens: [
      {
        to: "/relatorio/relatorio-de-estoque",
        title: "Estoque",
        fullTitle: "Relatórios de Estoques",
        id: 9,
      },
      {
        to: "/relatorio/relatorio-de-endereco",
        title: "Endereço",
        fullTitle: "Relatórios de Endereços",
        id: 10,
      },
      {
        to: "/relatorio/relatorio-de-produtividade-expedicao",
        title: "Produtividade",
        fullTitle: "Produtividade Expedição",
        id: 11,
      },
      {
        to: "/relatorio/relatorio-de-vencimentos",
        title: "Vencimento",
        fullTitle: "Relatório Vencimentos",
        id: 12,
      },
      {
        to: "/relatorio/relatorio-de-abastecimento",
        title: "Abastecimento",
        fullTitle: "Relatórios de Abastecimentos",
        id: 13,
      },
      {
        to: "/relatorio/relatorio-de-fotos",
        title: "Fotos",
        fullTitle: "Fotos",
        id: 14,
      },
      {
        to: "/relatorio/relatorio-de-corte",
        title: "Corte",
        fullTitle: "Relatórios de Corte",
        id: 15,
      },
      {
        to: "/relatorio/extrato",
        title: "Extrato",
        fullTitle: "Extrato Movimentação",
        id: 16,
      },
      {
        to: "/relatorio/inventario",
        title: "Inventário",
        fullTitle: "Relatório de Inventário",
        id: 17,
      },
      {
        to: "/relatorio/manifesto-entrega",
        title: "Manifesto de Entrega",
        fullTitle: "Manifesto de Entrega",
        id: 18,
      },
    ],
  },

  routes: [
    {
      path: "/relatorio",
      element: <RelatorioDashboard />,
    },
    {
      path: "/relatorio/relatorio-de-estoque",
      element: <Estoques />,
    },
    {
      path: "/relatorio/relatorio-de-endereco",
      element: <Endereco />,
    },
    {
      path: "/relatorio/relatorio-de-vencimentos",
      element: (
        <PeriodProvider>
          <RelatorioVecimento />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-produtividade-expedicao",
      element: (
        <PeriodProvider>
          <PainelExpedicao />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-abastecimento",
      element: (
        <PeriodProvider>
          <RelatorioAbastecimento />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-corte",
      element: (
        <PeriodProvider>
          <RelatorioCote />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-fotos",
      element: (
        <PeriodProvider>
          <RelatorioFotos />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/extrato",
      element: <ExtratoMovimentacao />,
    },
    {
      path: "/relatorio/inventario",
      element: <RelatorioInventario />,
    },
    {
      path: "/relatorio/manifesto-entrega",
      element: <BuscarManifestoEntrega />,
    },
    {
      path: "/relatorio/manifesto-entrega/:idCarregamento",
      element: <ManifestoEntrega />,
    },
  ],
};

export default ModuleRelatorio;
